import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import styles from './AnimatedRadioGroup.module.scss';

const AnimatedRadioGroup = ({
  options = [],
  value,
  onChange,
  name = 'radio-group',
  className = '',
  useindicator = false,
  containerClassName = ''
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const containerRef = useRef(null);
  const buttonRefs = useRef([]);



  useLayoutEffect(() => {
    if (value !== undefined) {
      const index = options.findIndex(option => option.value === value);
      if (index !== -1) {
        setSelectedIndex(index);
      }
    }
  }, [value, options]);

  // const updateIndicatorPosition = () => {
  //   if (buttonRefs.current[selectedIndex] && containerRef.current) {
  //     const selectedButton = buttonRefs.current[selectedIndex];

  //     setIndicatorStyle({
  //       transform: `translateX(${selectedIndex === 0 ? 0 : selectedButton.offsetLeft - 3}px)`,
  //       width: `${selectedButton.offsetWidth}px`,
  //       height: `${selectedButton.offsetHeight}px`,
  //     });
  //   }
  // };

  // useEffect(() => {
  //   updateIndicatorPosition();
  // }, [selectedIndex, options]);



  const handleOptionClick = (option, index) => {
    setSelectedIndex(index);
    if (onChange) {
      onChange(option.value);
    }
  };

  // useEffect(() => {
  //   const handleResize = () => {
  //     setTimeout(updateIndicatorPosition, 100);
  //   };

  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, [selectedIndex]);

  if (!options.length) return null;

  return (
    <div className={`${styles.radioGroupContainer} ${containerClassName}`}>
      <div
        ref={containerRef}
        className={`${styles.radioGroup} ${className}`}
      >
        {useindicator && <div
          className={styles.indicator}
          style={indicatorStyle}
        />}
        {options.map((option, index) => (
          <button
            key={option.value}
            ref={el => buttonRefs.current[index] = el}
            type="button"
            className={`${styles.option} ${selectedIndex === index ? styles.selected : ''}`}
            onClick={() => handleOptionClick(option, index)}
            role="radio"
            aria-checked={selectedIndex === index}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AnimatedRadioGroup; 